export enum TruckloadState {
  Draft = "Draft",
  Submitted = "Submitted",
  Confirmed = "Confirmed",
  Canceled = "Canceled",
}
